import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  FilterListsResponse,
  FilterListsResponse2,
  MetaPagination,
  ProfileResponse,
  ProfileResponse2,
} from '../../../api';

const getPlanningBoardState = createFeatureSelector('planningBoard');

export const getPlanningBoardList = createSelector(
  getPlanningBoardState,
  (
    state: any
  ): {
    data: Array<ProfileResponse> | Array<ProfileResponse2>;
    filters: FilterListsResponse | FilterListsResponse2 | undefined;
    pagination: MetaPagination | undefined;
    ok: boolean | undefined;
  } => state.list
);

export const getPlanningBoardFilters = createSelector(
  getPlanningBoardList,
  (list): FilterListsResponse | FilterListsResponse2 | undefined => list.filters
);

export const getPlanningBoardPagination = createSelector(
  getPlanningBoardList,
  (list): MetaPagination | undefined => list.pagination
);
